import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './styles.module.css';
export const Spinner = forwardRef(function Spinner({ className, size = 's', ...props }, ref) {
    return (React.createElement("div", { ref: ref, "aria-label": "loading...", role: "status", "aria-live": "polite", className: cn(styles.spinner, styles[size], className), ...props }));
});
